"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter = (function () {
    function IndexedDollarParameter() {
        this._indexationBasis = null;
        this._value = 0;
    }
    IndexedDollarParameter.prototype.initialise = function (value, indexationBasis) {
        this._indexationBasis = indexationBasis;
        this._value = value;
    };
    IndexedDollarParameter.prototype.resetValues = function (value) {
        this._value = value;
    };
    IndexedDollarParameter.prototype.index = function (year) {
        this._value = this._value * (1 + this._indexationBasis.getIndexationRate(year));
    };
    IndexedDollarParameter.prototype.resetIndexationBasis = function (indexationBasis) {
        this._indexationBasis = indexationBasis;
    };
    Object.defineProperty(IndexedDollarParameter.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    IndexedDollarParameter.prototype.getIndexationInYear = function (year) {
        return this._indexationBasis.getIndexationRate(year);
    };
    return IndexedDollarParameter;
}());
exports.IndexedDollarParameter = IndexedDollarParameter;
//# sourceMappingURL=IndexedDollarParameter.js.map